import { type ReactNode, createContext, useContext, useState } from "react";

interface Current {
  projectId: string | null;
  projectName: string | null;
  setCurrent: (id: string | null, name: string | null) => void;
}
const Ctx = createContext<Current>({ projectId: null, projectName: null, setCurrent: () => {} });

export function CurrentProjectProvider({ children }: { children: ReactNode }) {
  const [projectId, setId] = useState<string | null>(() => localStorage.getItem("cur_project_id"));
  const [projectName, setName] = useState<string | null>(() =>
    localStorage.getItem("cur_project_name"),
  );
  const setCurrent = (id: string | null, name: string | null) => {
    if (id) {
      localStorage.setItem("cur_project_id", id);
      localStorage.setItem("cur_project_name", name ?? "");
    } else {
      localStorage.removeItem("cur_project_id");
      localStorage.removeItem("cur_project_name");
    }
    setId(id);
    setName(name);
  };
  return <Ctx.Provider value={{ projectId, projectName, setCurrent }}>{children}</Ctx.Provider>;
}

export function useCurrentProject() {
  return useContext(Ctx);
}
